<template>

    <b-container v-if="load.Loading" class="container-basic-spinner">
        <spinner  />
    </b-container>
    <div v-else>

        <b-row class="table-nav-row">
            <b-nav>
                <b-nav-item v-if="entity.isExistsActive()"
                            class="table-nav" 
                            :disabled="entity.isSelectedActive()" 
                            @click="entity.selectActive()">
                    Активные
                </b-nav-item>
                <span v-if="entity.isExistsActive()" class="v-center" > / </span>

                <b-nav-item v-if="entity.isExistsArchival()"
                            class="table-nav" 
                            :disabled="entity.isSelectedArchival()" 
                            @click="entity.selectArchival()">
                    Архивные
                </b-nav-item>
                <span v-if="entity.isExistsArchival()" class="v-center"> / </span>

                <b-nav-item class="table-nav" 
                            :disabled="entity.isSelectedAll()" 
                            @click="entity.selectAll()">
                    Все
                </b-nav-item>

            </b-nav>
            
        </b-row>

        <custom-table-list :options="users"
                           :fields="fields"
                           :is-users="true"
                           placeholder-search="Поиск пользователей"
                           edit-link="/Admin/Users/Edit" />
    </div>

    

</template>
<script>
import apiService from "@/services/api.service"
import Consts from '@/store/models/consts/adminConsts'

import Spinner from "@/components/shared/Spinner"
import Loading from "@/store/models/Loading"

import UsersModel from '@/store/models/admin/users/Users'
import CustomTableList from '@/components/shared/CustomTableList'

export default {
    computed: {
        users: function() {
            return this.entity.SelectedStatus
                        ? this.entity.filterByStatus()
                        : this.entity.Users;
        }
    },
    data: function() {
        var load = new Loading();
        this.getUsers(load);

        return {
            load: load,
            entity: null,
            fields: [
                {
                    key: 'FullName',
                    label: 'ФИО',
                    sortable: true,
                    tdClass: value => {
                        return "p-10-5"
                    }
                },
                {
                    key: 'Rights',
                    label: 'Права',
                    sortable: true,
                    formatter: value => {
                        return Consts.UserRights.find(e => e.Id == value).Text;
                    },
                    tdClass: value => {
                        return "p-10-5"
                    }
                },
                {
                    key: 'Dax',
                    label: 'DAX',
                    sortable: true,
                    tdClass: value => {
                        return "p-10-5"
                    }
                },
                {
                    key: 'Post',
                    label: 'Должность',
                    sortable: true,
                    tdClass: value => {
                        return "p-10-5"
                    },
                    formatter: value => {
                        return value == "Эксклюзив.торг.представитель"
                                    ? "Эксклюзив. торг .представитель"
                                    : value == "Фокусный торг.представитель"
                                            ? "Фокусный торг. представитель"
                                            : value;
                    }
                },
                {
                    key: 'Email',
                    label: 'Email',
                    sortable: true,
                    tdClass: value => {
                        return "p-10-5"
                    }
                },
                {
                    key: 'Phone',
                    label: 'Номер',
                    sortable: true,
                    tdClass: value => {
                        return "p-10-5"
                    }
                },
                {
                    key: 'Status',
                    label: 'Статус',
                    sortable: true,
                    formatter: value => {
                        return Consts.UserStatus.find(e => e.Id == value).Text;
                    },
                    tdClass: value => {
                        return "p-10-5"
                    }
                },
                {
                    key: 'Os',
                    label: 'Версия ОС',
                    sortable: true,
                    tdClass: value => {
                        return "p-10-5"
                    }
                },
                {
                    key: 'Version',
                    label: 'Версия приложения',
                    sortable: true,
                    tdClass: value => {
                        return "p-10-5"
                    }
                },
                {
                    key: 'Device',
                    label: 'Наименование устройства',
                    sortable: true,
                    tdClass: value => {
                        return "p-10-5"
                    }
                },
            ]            
        }
    },
    methods: {
        getUsers: function (load) {
            load.Calculate(true);

            apiService.Admin.Users.GetAll()
                .then(response => {
                    this.entity = new UsersModel().mapFromDto(response.data);
                    load.Calculate(false);
                })
                .catch(error => load.Calculate(false));
        }
    },
    components: {
        Spinner,
        CustomTableList
    }
}
</script>